import { FEATURES_SUCCESS } from 'actions/features';

const initialState = {
  ready: false,
  flags: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FEATURES_SUCCESS:
      return { ready: true, flags: action.payload || {} };
    default:
      return state;
  }
};

export default reducer;
